/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiWebhookTrigger {
    ALERT = 'ALERT',
    PERSON_STATUS = 'PERSON_STATUS',
    ALERT_STATUS = 'ALERT_STATUS',
    SCREENING_ALERT_STATUS = 'SCREENING_ALERT_STATUS',
    SCREENING_ALERT = 'SCREENING_ALERT',
    SCREENING_ALERT_UPDATE = 'SCREENING_ALERT_UPDATE',
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    FINAL_RISK = 'FINAL_RISK',
    CUSTOM_LIST_RECORD = 'CUSTOM_LIST_RECORD',
    MANUAL_ALERT = 'MANUAL_ALERT',
    MANUAL_ALERT_STATUS = 'MANUAL_ALERT_STATUS'
}


export function instanceOfApiWebhookTrigger(value: any): boolean {
    for (const key in ApiWebhookTrigger) {
        if (Object.prototype.hasOwnProperty.call(ApiWebhookTrigger, key)) {
            if (ApiWebhookTrigger[key as keyof typeof ApiWebhookTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiWebhookTriggerFromJSON(json: any): ApiWebhookTrigger {
    return ApiWebhookTriggerFromJSONTyped(json, false);
}

export function ApiWebhookTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhookTrigger {
    return json as ApiWebhookTrigger;
}

export function ApiWebhookTriggerToJSON(value?: ApiWebhookTrigger | null): any {
    return value as any;
}

export function ApiWebhookTriggerToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiWebhookTrigger {
    return value as ApiWebhookTrigger;
}

